var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbnails(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 20 20",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20 18h-20v-4h20zm-14.29-3h-2.924v2h2.924zm5.785 0h-2.925v2h2.925zm2.762 0v2h2.925v-2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m20 6h-20v-4h20zm-11.43-1h2.925v-2h-2.925zm-2.86 0v-2h-2.924v2zm11.472 0v-2h-2.925v2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m2.5 5.511h2v9.009h-2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m15.5 5.511h2v9.009h-2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnails);
export default __webpack_public_path__ + "static/media/thumbnails.4514afde71293eac156d7a818eae19a9.svg";
export { ForwardRef as ReactComponent };